import { render, staticRenderFns } from "./ConfirmationEducation.vue?vue&type=template&id=2b68d402&scoped=true"
import script from "./ConfirmationEducation.vue?vue&type=script&lang=ts"
export * from "./ConfirmationEducation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b68d402",
  null
  
)

export default component.exports